/* eslint-disable no-nested-ternary */
/* eslint-disable padding-line-between-statements */
import { TranslatorContext, IntlContext } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import {
    validationDefaultProps,
    validationPropTypes,
    withValidation,
} from '@xengage/gw-portals-validation-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';
import styles from './ClauseComponent.module.scss';
import messages from './ClauseComponentVM.messages';
import TWIAHOCoveragesSummaryUtil from '../../../capabilities-react/twia-capability-quoteandbind-TWIAResidential-react/util/TWIAHOCoveragesSummaryUtil';
import TFPAHoCustomQuoteUtil from '../../../capabilities-react/tfpa-capability-quoteandbind-TFPAResidential-react/util/TFPAHoCustomQuoteUtil';
import TFPACoverablesUtils from 'tfpa-capability-quoteandbind-residential-react/util/TFPACoverablesUtils';

/**
 * Generate field metadata for terms
 * @param {object} term the clause terms
 * @param {string} termPathPrefix prefix for the term's path
 * @param {object} translator to translate the strings/objects
 * @returns {Object} the field metadata
 */

const displayAmountFields = ["Limit % of Dwelling Coverage", "Deductible", "Limit % Of Coverage A", 
    "Limit - % of Personal Property Coverage", "Liability Limit", "Limit - Per Person", 
    "Limit - Per Occurrence", "Limit", "Limit - % of Dwelling Coverage", "Other Perils", 
    "Wind or Hail"];

function getMetadataForField(term, termPathPrefix, translator, showError, limitError, 
    isResidentialSummary, isCommercialSummary, clauseTerms, 
    isTFPAResidentialSummary, submissionVM) {
    const hasAvailableValues =
    _.has(term, 'options') && (!_.isEmpty(term.options) || term.publicID === "CPBldgCovDeductible"); // DE15929
    const valueType = _.has(term, 'valueType') && term.valueType;
    const limitTerm = _.find(clauseTerms, (termField) => termField.name === "Limit") // DE15815
    const selectedUWCompany = _.get(submissionVM, 'baseData.associationName_TWIA.value.code') ||
         _.get(submissionVM,'lobData.homeowners.associationName_TWIA.value.code');
    const isTFPA = selectedUWCompany === 'tfpa'
    let constructionType;
    if(isTFPA){
        constructionType = TFPACoverablesUtils.getConstructionType(submissionVM);
    }
 
    const availableValues =
        hasAvailableValues &&
        term.options
            .filter(option => {
                // Filtering out the None Selected value as the backend sets the code value
                // for None Selected to be an empty string. This results in the option not
                // showing in the dropdown select component. We are handling this by using
                // None Selected as a placeholder which will always be shown to the user
                return option.name !== translator(messages.noneSelected);
            })
            .map(option => {
                return {
                    code: '',
                    id: '',
                    ...option,
                };
            });

    if (hasAvailableValues && valueType === 'bit') {
        // chosenTerm for bit terms with more than 2 choices?
        return {
            component: 'Toggle',
            componentProps: {
                path: `${termPathPrefix}.directBooleanValue`,
                value: term.directBooleanValue,
                showErrors: showError // US26345
            },
        };
    }

    if (!hasAvailableValues && valueType === 'datetime') {
        return {
            component: 'DateTime',
            componentProps: {
                dataType: 'string',
                onValueChange: 'onChangeClause',
                onBlur: 'onSyncCoverages',
                showErrors: showError, // US26345
                value: term.directDateValue,
                path: `${termPathPrefix}.directDateValue`,
                labelTime: {
                    id: '',
                    defaultMessage: '',
                },
            },
        };
    }

    if (valueType === 'shorttext' || valueType === 'longtext') {
        return {
            component: 'TextArea',
            componentProps: {
                onValueChange: 'onChangeClause',
                onBlur: 'onSyncCoverages',
                path: `${termPathPrefix}.directStringValue`,
                value: term.directStringValue,
                showErrors: showError // US26345
            },
        };
    }

    if (hasAvailableValues && !valueType) {
        const componentDetails = {
            component: 'DropdownSelect',
            componentProps: {
                placeholder: '--Select Option--',
                availableValues,
                // DE15815 DE15816 DE16100
                path: (isResidentialSummary || isCommercialSummary || isTFPAResidentialSummary) && displayAmountFields.includes(term.name)? `${termPathPrefix}.displayAmount_TWIA` : `${termPathPrefix}.chosenTerm`, //US26839
                value: (isResidentialSummary || isCommercialSummary ||isTFPAResidentialSummary) && displayAmountFields.includes(term.name)
                ? (term.displayAmount_TWIA || TWIAHOCoveragesSummaryUtil.getDeductibleDisplayInfo(term, limitTerm))
                 : term.chosenTerm , //US26839
                showErrors: showError // US26345
            },
        };

        if (_.some(term.options, ['name', translator(messages.noneSelected)])) {
            _.set(
                componentDetails,
                'componentProps.placeholder',
                translator(messages.noneSelected)
            );
            _.set(
                componentDetails,
                'componentProps.alwaysShowPlaceholder',
                true
            );
        }
        return componentDetails;
    }
    const getMessageByMinMax = (directValue) => {
        let key = 'maxValue';
        const isMHRes = _.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') === "TWRM";
        const selectedUWCompany = _.get(submissionVM, 'baseData.associationName_TWIA.value.code') ||
         _.get(submissionVM,'lobData.homeowners.associationName_TWIA.value.code');
        const isTWIA = selectedUWCompany === 'twia' ;

        if (term.coveragePublicID === 'TDP_017'){
            if (directValue > term.directValueMax) {
                key = 'maxValue';
            } else if (directValue < term.directValueMin) {
                key = 'minValue';
            }
        }
        else if (directValue > term.directValueMax) {
            key = isTWIA ? 'selectedValue' : 'noGreaterThan';
        } else if (directValue < term.directValueMin) {
            key = isTWIA ? 'selectedValue' : 'noLesssThan';
        }

        // US28796
        if ((term.coveragePublicID === "TW_DW_Property_Coverages" ||
             term.coveragePublicID === "TWRD_DW_Personal_Property_Cov")
            && term.directValueMax && term.directValueMin && isMHRes) {
                
            key = term.publicID === "z1ejuk2umgcg1a8f7k8t5taihe9" ? 'minMaxStuctureLimit' : 'minMaxPropertyLimit'
        }

        return messages[key];
    };

    // US26258
    const checkValidMultipleExt = (base) => {
        if (base.directValueMultipleOf_TWIA && base.directValue) {
            const fval = parseFloat(base.directValue);
            const expected = (Math.ceil(fval / base.directValueMultipleOf_TWIA)
            * base.directValueMultipleOf_TWIA);
            const result = expected !== fval;
           
            return result;
        }
 
        return false;
    }

    // DE16380 added condition for the validation
    const checkValidMultipleExtTfpa = (base) => {
        if (base.directValueMultipleOf_TWIA === undefined && 
            base.name !== "Estimated Replacement Cost Value" && 
            base.name !== "Estimated Actual Cash Value"){
        const fvalue = parseFloat(base.directValue); 
        return isNaN(fvalue) || fvalue % 100 !== 0;
        }
    };
    // US28796
    const getMessageProps = (term) => {
        const MHMessage = translator(getMessageByMinMax(term.directValue), {
            maxValue: `$${term.directValueMax}`,
            minValue: `$${term.directValueMin}`,
        })
        const isMHRes = _.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') === "TWRM";

        return {
            validationMaxValue: (isMHRes || term.directValue > term.directValueMax || term.directValue < term.directValueMin)
             ? MHMessage
                : translator(getMessageByMinMax(term.directValue), {
                    maxValue: `$${term.directValueMax}`,
                }),
            validationMinValue: (isMHRes || term.directValue > term.directValueMax || term.directValue < term.directValueMin) 
            ? MHMessage
                : translator(getMessageByMinMax(term.directValue), {
                    minValue: `$${term.directValueMin}`,
                })
        }
    }
        
   // DE16141 // DE16922
    return (!isCommercialSummary && !isTFPAResidentialSummary && !isResidentialSummary) ? {
        component: 'InputNumber',
        componentProps: {
            onValueChange: 'onChangeClause',
            onBlur: 'onSyncCoverages',
            value: term.directValue,
            maxValue: term.directValueMax,
            minValue: term.directValueMin,
            path: `${termPathPrefix}.directValue`,
            showErrors: showError || (limitError && term.name === 'Limit' && term.directValue !== undefined), // US26345
            validationMessages: (term.directValueMultipleOf_TWIA !== undefined) // DE16380
                ? checkValidMultipleExt(term)
                    ? [translator(messages.multipleOf, { multipleValue: `$${term.directValueMultipleOf_TWIA}` })]
                    : []
                : checkValidMultipleExtTfpa(term) && constructionType !== undefined
                    && constructionType !== 'MH_ext' && term.directValue !== undefined
                    && term.type !== 'DirectLimitTDP017Type' // DE16462
                    ? [translator(messages.multipleOfTfpa)]
                    : [],
            messageProps: getMessageProps(term)
        },
    }
    : {
        component: 'Currency',
        componentProps: {
            value: { amount: term.directValue, currency: 'USD' },
            showFractions: false,
            path: `$${termPathPrefix}.directValue`,
        },
    };
}

function isClauseLoading(clause, loadingClause) {
    if (_.isString(loadingClause)) {
        return loadingClause === clause.publicID;
    }
    if (_.isBoolean(loadingClause)) {
        return loadingClause;
    }
    return false;
}

function getPath(changedValuePath) {
    // onBlur event returns an object instead of path as a String
    const pathToNormalise = _.isObject(changedValuePath)
        ? changedValuePath.model
        : changedValuePath;

    return pathToNormalise;
}

function getRelativePath(changedValuePath) {
    // US26350
    if(_.includes(changedValuePath, 'coveragesAdditionalFields_TWIA')){
        return changedValuePath
    }

    const [relativePath] = changedValuePath.match(
        /(selected|terms\.children\[\d+\](\.\w+)+)/
    );

    return relativePath.replace(/\.children/g, '');
}

function checkTermReadOnly(isEditable, submissionVM, clause, term){
    if (submissionVM) {
        const policyType = submissionVM.lobData.homeowners_tfpa?.policyType_TWIA?.value?.code || 
        submissionVM.lobData.homeowners_tfpa?.coverables?.policyType_Ext?.value?.code;
        const tfpaCustomQuote = TFPAHoCustomQuoteUtil[policyType];
        if (tfpaCustomQuote) {
            return tfpaCustomQuote.readonlyTerm(clause, term, submissionVM);
        }
        return !isEditable
    }
   
    return !isEditable
}

class SingleClauseComponentVM extends Component {
    /**
     * @memberof gw-components-platform-react.SingleClauseComponentVM
     * @prop {Object} propTypes - the props that are passed to this component
     * @prop {string} propTypes.path - path to clause in the view modal
     * @prop {object} propTypes.value - the clause
     * @prop {function} propTypes.onChangeSubmissionAndSync - callback when change is made
     * @prop {function} propTypes.onChangeClause - callback when change is made
     * @prop {function} propTypes.onSyncCoverages - callback to check if clause should call backend
     * @prop {string} propTypes.loadingClause - the clause publicID that is loading
     * @prop {string} propTypes.loadingClauseMessage - loading message to be shown while loading
     * @prop {string} propTypes.isEditable - if the clauses should not be editable
     * @prop {string} propTypes.labelTop - if the clause term label should be on the top
     * @prop {string} propTypes.containerClassName - clause container class
     * @prop {string} propTypes.idPrefix - string to prefix all the ID's
     * @prop {string} propTypes.description - clause description
     * @prop {string} propTypes.onValidate - returns if the values are valid
     * @prop {bool} propTypes.showAmount - determine to show amount next to clause name
     */

    static propTypes = {
        path: PropTypes.string.isRequired,
        value: PropTypes.shape({}).isRequired,
        phoneWide: PropTypes.shape({}),
        onChangeSubmissionAndSync: PropTypes.func,
        onChangeClause: PropTypes.func,
        onSyncCoverages: PropTypes.func,
        onScheduleChange: PropTypes.func,
        onValidate: PropTypes.func,
        loadingClause: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        loadingClauseMessage: PropTypes.string,
        isEditable: PropTypes.bool,
        labelTop: PropTypes.bool,
        containerClassName: PropTypes.string,
        idPrefix: PropTypes.string,
        labelPosition: PropTypes.string,
        description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        showAmount: PropTypes.bool,
        ...validationPropTypes,
    };

    static defaultProps = {
        onChangeSubmissionAndSync: undefined,
        onChangeClause: undefined,
        onSyncCoverages: undefined,
        onScheduleChange: undefined,
        loadingClause: undefined,
        loadingClauseMessage: '',
        onValidate: undefined,
        isEditable: true,
        labelTop: false,
        containerClassName: undefined,
        idPrefix: '',
        labelPosition: 'left',
        description: undefined,
        showAmount: true,
        phoneWide: {
            labelPosition: 'top',
        },
        ...validationDefaultProps,
    };

    static contextType = TranslatorContext;

    constructor(props) {
        super(props);
        this.validationMessagesRef = createRef();
    }

    componentDidMount() {
        const {
            onValidate,
            value: clause,
            isComponentValid,
            registerComponentValidation,
        } = this.props;

        if (onValidate) {
            registerComponentValidation(this.isMetadataValid);
            onValidate(isComponentValid, clause.publicID);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            onValidate,
            value: newClause,
            isComponentValid,
            hasValidationChanged,
        } = this.props;
        const { value: oldClause } = prevProps;

        if (
            (!_.isEqual(newClause, oldClause) || hasValidationChanged) &&
            onValidate
        ) {
            // US26345 - if coverage is unselected, send isComponentValid as true
            if(oldClause.updated && !oldClause.selected){
                onValidate(true, newClause.publicID)
                // to delete the validation messages upon de-selecting the coverage
                for(const e in this.validationMessagesRef.current) {
                    if(e.includes(this.props.path)) {
                        delete this.validationMessagesRef.current[e]
                    }
                }
            }else{
                onValidate(isComponentValid, newClause.publicID);
            }
        }
    }

    /**
     * Generate clauses schedule metadata from clause
     * @param {object} clauseSchedule the clause schedule
     * @param {string} clausePublicID the clause publicID
     * @returns {object | null} the metadata to render
     */
    getScheduleData(clauseSchedule, clausePublicID) {
        const { path, idPrefix, labelPosition } = this.props;
        const schedulePath = `${path}.schedule`;

        if (_.isEmpty(clauseSchedule)) {
            return null;
        }

        return [
            {
                id: `${idPrefix}ClauseSchedule_[${clausePublicID}]`,
                type: 'field',
                component: 'ScheduleItemsComponent',
                componentProps: {
                    path: schedulePath,
                    onScheduleChange: 'onScheduleChange',
                    value: clauseSchedule,
                    labelPosition,
                    showTitle: false,
                },
            },
        ];
    }

    // DE16922
    getTermLabel(term, isResidentialSummary, isCommercialSummary) {
        if((isResidentialSummary || isCommercialSummary) 
            && displayAmountFields.includes(term.name) && term.chosenTermValue.includes('%')){
            return `${term.name} (${term.chosenTermValue?.substring(0, term.chosenTermValue.indexOf("%") + 1)})`
        } 
        
        return term.name
                        
    }

    /**
     * Generate clauses term metadata from clause
     * @param {object} clauseTerms the clause terms
     * @param {string} clausePublicID the clause publicID
     * @returns {object | null} the metadata to render
     */
    getTermMetaData(clauseTerms, clausePublicID,clause) {
        const {
            isEditable,
            path,
            labelTop,
            idPrefix,
            labelPosition,
            phoneWide,
            showError,
            limitError,
            isCommericalCoverageScreen,
            isResidentialSummary, // US26345 && US26330
            splitByClauseCategory,
            isCommercialSummary,
            submissionVM,
            isTFPAResidentialSummary //US26840
        } = this.props;

        // DE16124
        const termsNotVisible =["zp2gc9babmt282dtirsq1fpbtoa","z1hi8dpah82obcs9bq283s2ueea",
            "zd2hgl7ijbuss8j2o0b7d68v7ba","zosio6b3mk6r3a1r80rql414cqa",
            "zp9hk2vsvmb01aq1od7d0vre92b","zjiji7lqf4ecu7t7b4go4955si8",
            "zhoi2pnltl8mk04jqau09t3pae8", "z5pj2qdchqr6i6502ehju6l8vf9", 
            "zrlh49e3865hg02d8hmo433v2ba"]
        const translator = this.context;
        const isPolicyChange = submissionVM?.baseData?.jobType?.value?.code === "PolicyChange";
        return clauseTerms.map((term, index) => {
            const termPathPrefix = `${path}.terms.children[${index}]`;
            //const percentValue = term.chosenTermValue.split(' ')[0]; // DE15815
            let clauseTermClass = 'clause_term';
            clauseTermClass += !isEditable ? ' clauseTermReadonly' : '';
            const termComponent = {
                id: `${idPrefix}ClauseTerm_[${clausePublicID}]_[${index}]`,
                type: 'field',
                componentProps: {
                    // US26345 - reverting included display for term & DE15817
                    // DE16178
                    label: this.getTermLabel(term, isResidentialSummary, isCommercialSummary),
                    path: `${termPathPrefix}.chosenTerm`,
                    // US26330 To Show Coverges on summary screen
                    readOnly: isTFPAResidentialSummary ? true :
                        (term.patternCode === 'DPDW_Dwelling_Limit_HOE' && isPolicyChange) ? false :
                            checkTermReadOnly(isEditable, submissionVM, clause, term), // US26840, DE18606
                    value: term.chosenTerm,
                    labelPosition: labelPosition === true ? 'top':'left' , //labelPosition,
                    layout: 'full-width', //labelTop ? 'full-width' : null,
                    onValueChange: 'onChangeAndSyncClause',
                    required: isEditable && term.required,
                    showRequired: isEditable && term.required,
                    visible: isCommercialSummary && termsNotVisible.includes(term.publicID) ?false:term.visible_TWIA, // US28766 and US28769
                    disabled: !term.editable_TWIA,
                    className: clauseTermClass,
                    phoneWide,
                },
            };

            return _.merge(
                {},
                termComponent,
                // US26345 - passing showError param to display field level validations
                getMetadataForField(term, termPathPrefix, translator, showError, 
                    limitError, isResidentialSummary, isCommercialSummary, 
                    clauseTerms, isTFPAResidentialSummary, submissionVM)
            );
        });
    }

    // US26243 - MSB button for building coverage
    getMSBMetaData_Ext(clausePublicID){
        const {
            loadMSBSite
        } = this.props;

        const msbButton = {
            id: `msbButton[${clausePublicID}]`,
            type: 'action',
            component: 'Button',
            content: {
                id: "",
                defaultMessage: "Launch MSB"
            },
            componentProps: {
                onClick: loadMSBSite,
                className: 'buttonwidth'
            },
        };

        return [msbButton]
    }


    shouldDisableCostFields_Ext(disableAdditionalFields){
        const { submissionVM } = this.props;
        const selectedUWCompany = _.get(submissionVM, 'baseData.associationName_TWIA.value.code') ||
         _.get(submissionVM,'lobData.homeowners.associationName_TWIA.value.code'); //DE17300
        const isTWIA = selectedUWCompany === 'twia' ;
        // valid for TWIA, 
        if (isTWIA){
            const selectedStructureType = _.get(submissionVM, 'lobData.homeowners.coverables.construction.structureType_TWIA.value');
            if (!_.isUndefined(selectedStructureType) && (selectedStructureType.code === '1Family' ||
                selectedStructureType.code ==='2Family' ||
                selectedStructureType.code === 'IndividuallyTH' ||
                selectedStructureType.code == 'PublicHousing'))
                {
                    return true;
                }
                else {
                    return disableAdditionalFields;
                }
        } else {
            // disable for TFPA
            return true;
        }
        
    }

    // US26350 - additional fields metadata
    getAdditionalFieldsMetaData_Ext(fieldPath, clausePublicID) {
        const {
            submissionVM,
            disableAdditionalFields,
            phoneWide,
            showAdditionalFieldError
        } = this.props;

        const additionalFields = _.get(submissionVM, fieldPath)
        const clauseTermClass = 'clause_term';
        let additionalFieldsArray = null;

        const replacementCost = {
            id: `replacementCost[${clausePublicID}]`,
            type: 'field',
            component: 'InputNumber',
            componentProps: {
                label: 'Estimated Replacement Cost',
                path: clausePublicID === 'TW_DW_Property_Coverages'
                ? `${fieldPath}.replacementCashValue_TWIA`
                : `${fieldPath}.replacementCashValuePersonal_TWIA`,
                labelPosition: 'left',
                onValueChange: 'onChangeClause',
                onBlur: 'onSyncCoverages',
                value: clausePublicID === 'TW_DW_Property_Coverages'
                ? additionalFields.replacementCashValue_TWIA?.value
                : additionalFields.replacementCashValuePersonal_TWIA?.value,
                showErrors: showAdditionalFieldError,
                required: true,
                showRequired: true,
               disabled:this.shouldDisableCostFields_Ext(disableAdditionalFields), //disableAdditionalFields,
                className: clauseTermClass,
                validationMessages: clausePublicID === "TW_DW_Property_Coverages" ?
                additionalFields.replacementCashValue_TWIA?.aspects.validationMessages :
                additionalFields.replacementCashValuePersonal_TWIA?.aspects.validationMessages,
                visible: clausePublicID === "TW_DW_Property_Coverages"
                ? additionalFields.replacementCashValue_TWIA?.aspects.visible
                : additionalFields.replacementCashValuePersonal_TWIA?.aspects.visible,
                phoneWide
            },
        };

        const actualCost = {
            id: `actualCost[${clausePublicID}]`,
            type: 'field',
            component: 'InputNumber',
            componentProps: {
                label: 'Estimated Actual Cash Value',
                path: clausePublicID === 'TW_DW_Property_Coverages'
                ? `${fieldPath}.actualCashValue_TWIA`
                : `${fieldPath}.actualCashValuePersonal_TWIA`,
                labelPosition: 'left',
                onValueChange: 'onChangeClause',
                onBlur: 'onSyncCoverages',
                value: clausePublicID === 'TW_DW_Property_Coverages'
                && (additionalFields.actualCashValue_TWIA || additionalFields.actualCashValuePersonal_TWIA)
                ? additionalFields.actualCashValue_TWIA?.value
                : additionalFields.actualCashValuePersonal_TWIA?.value,
                required: true,
                showRequired: true,
                showErrors: showAdditionalFieldError,
                disabled: this.shouldDisableCostFields_Ext(disableAdditionalFields),//disableAdditionalFields,
                className: clauseTermClass,
                validationMessages: clausePublicID === "TW_DW_Property_Coverages" ?
                additionalFields.actualCashValue_TWIA?.aspects.validationMessages :
                additionalFields.actualCashValuePersonal_TWIA?.aspects.validationMessages,
                visible: clausePublicID === "TW_DW_Property_Coverages"
                ? additionalFields.actualCashValue_TWIA?.aspects.visible
                : additionalFields.actualCashValuePersonal_TWIA?.aspects.visible,
                phoneWide
            },
        };

        if(replacementCost && actualCost){
            additionalFieldsArray = [replacementCost, actualCost];
        }

        return additionalFieldsArray
    }

    /**
     * Generate clauses sub element metadata from clause
     * @param {object} clause the clause to get data from
     * @returns {object | null} the metadata to render
     */
    getClauseData(clause) {
        const { idPrefix, additionalFieldsPath,isResidentialSummary, msbButtonVisible } = this.props;
        // US26350 - additional fields metadata
        const additionalFieldsTwia = (clause.publicID === 'TW_DW_Property_Coverages' ||
        clause.publicID === 'TWRD_DW_Personal_Property_Cov') && clause.selected && !isResidentialSummary // US26330 To Show Coverges on summary screen
        ? this.getAdditionalFieldsMetaData_Ext(additionalFieldsPath, clause.publicID)
        : null;
        const terms = !_.isEmpty(clause.terms)
            ? this.getTermMetaData(clause.terms, clause.publicID, clause)
            : null;
        const schedules = _.has(clause, 'schedule')
            ? this.getScheduleData(clause.schedule, clause.publicID)
            : null;
        const launchMSB = (clause.publicID === 'CPBldgCov') && clause.selected && msbButtonVisible
        ? this.getMSBMetaData_Ext(clause.publicID)
        : null;
        // US26350
        const mergeElements = (...arrays) => [].concat(...arrays.filter(Array.isArray));
        let clauseSubElements;

        if(additionalFieldsTwia){
            clauseSubElements = mergeElements(additionalFieldsTwia, terms, schedules);
        }else if(launchMSB){
            clauseSubElements = mergeElements(launchMSB, terms, schedules);
        }else{
            clauseSubElements = _.merge([], terms, schedules);
        }

        // const clauseSubElements = _.merge([], terms, schedules);

        return !_.isEmpty(clauseSubElements)
            ? [
                  {
                      id: `${idPrefix}ClauseElementContainer_[${clause.publicID}]`,
                      type: 'container',
                      component: 'div',
                      componentProps: { className: 'clause_element_container' },
                      contentLayout: { component: 'grid' },
                      content: clauseSubElements,
                  },
              ]
            : null;
    }

    isMetadataValid = () => {
        return _.isEmpty(this.validationMessagesRef.current) && this.props.value.isValid;
    }

    /**
     * Generate metadata from value provided from props
     * @returns {object} the metadata to render
     */
    generateMetadata = () => {
        const {
            value: clause = {},
            path,
            loadingClause,
            loadingClauseMessage,
            isEditable,
            containerClassName,
            description,
            idPrefix,
            showAmount,
            showError,
            showAdditionalFieldError,
            showCoverageNameAmount
        } = this.props;

        const isTooltipVisible =
            description ||
            (clause.description !== clause.name &&
                !_.isEmpty(clause.description));

        return {
            content: [
                {
                    id: `${idPrefix}Clause_[${clause.publicID}]`,
                    type: 'field',
                    component: 'ClauseComponent',
                    componentProps: {
                        id: `${idPrefix}_${clause.publicID}`,
                        displayName: isEditable
                            ? clause.name
                            : description || clause.description,
                        showAmount:showAmount, // US28766 and US28769
                        amount: clause.amount,
                        path: `${path}.selected`,
                        readOnly: clause.required || !clause.editable_TWIA, // DE18060
                        value: clause.selected || clause.required,
                        checked: clause.selected || clause.required,
                        // US26350 - checking clause visibility
                        visible: clause.visible_TWIA,
                        onValueChange: 'onChangeAndSyncClause',
                        isEditable: isEditable , // US26330 To Show Coverges on summary screen
                        isLoading: isClauseLoading(clause, loadingClause),
                        loadingMessage: loadingClauseMessage,
                        showError: showAdditionalFieldError,
                        containerClassName: containerClassName,
                        description: isTooltipVisible
                            ? description || clause.description
                            : undefined,
                        showCoverageNameAmount
                    },
                    content: clause.selected
                        ? this.getClauseData(clause)
                        : null,
                },
            ],
        };
    };

    /**
     * Changes value and calls backend if needed
     * @param {object} value the new value
     * @param {string} changedValuePath the path to change
     * @returns {Promise}
     */
    handleScheduleChange = (value, changedValuePath) => {
        const { onScheduleChange } = this.props;

        if (onScheduleChange) {
            return Promise.resolve(onScheduleChange(value, changedValuePath));
        }
        return Promise.resolve();
    };

    /**
     * Changes value and calls backend if needed
     * @param {object} value the new value
     * @param {string} changedValuePath the path to change
     * @returns {Promise}
     */
    handleChangeAndSyncClause = (value, changedValuePath) => {
        const { onChangeSubmissionAndSync, value: clause, onValidate } = this.props;

        // US26345 - if coverage is unselected, send isComponentValid as true
        if(!value && _.includes(changedValuePath, 'selected')){
            onValidate(true, clause.publicID)
        }

        if (_.get(clause, getRelativePath(changedValuePath)) !== value) {
            if (onChangeSubmissionAndSync) {
                return Promise.resolve(
                    // US26350
                    onChangeSubmissionAndSync(value, changedValuePath, clause)
                );
            }
        }
        return Promise.resolve();
    };

    /**
     * Changes value
     * @param {object} value the new value
     * @param {string} changedValuePath the path to change
     * @returns {Promise}
     */
    handleChangeClause = (value, changedValuePath) => {
        const { onChangeClause, value: clause } = this.props;
        if (_.get(clause, getRelativePath(changedValuePath)) !== value) {
            if (onChangeClause) {
                return Promise.resolve(onChangeClause(value, changedValuePath,clause));
            }
        }
        return Promise.resolve();
    };

    /**
     * Calls backend if needed
     * @param {object} evt event
     * @param {string} changedValues the path to change
     * @returns {Promise}
     */
    handleSyncCoverages = (evt, changedValues) => {
        const { onSyncCoverages } = this.props;
        const { beforeValue, value: newValue, model } = changedValues;
        const actualChangedPath = getPath(model);

        if (model === undefined) {
            return Promise.resolve();
        }

        if (beforeValue !== newValue) {
            if (onSyncCoverages) {
                return Promise.resolve(
                    onSyncCoverages(newValue, actualChangedPath)
                );
            }
        }
        return Promise.resolve();
    };

    render() {
        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                onValueChange: this.handleChangeAndSyncClause,
                onChangeAndSyncClause: this.handleChangeAndSyncClause,
                onChangeClause: this.handleChangeClause,
                onSyncCoverages: this.handleSyncCoverages,
                onScheduleChange: this.handleScheduleChange,
            },
        };

        const overrides = {
            '@field': {
                // showOptional: true, // US26345 - not required to show optional
                onValidationChange: (isValid, path, message) => {
                    const fullPath = path;
                    const newMessages = {
                        ...this.validationMessagesRef.current,
                    };
                    if (isValid) {
                        delete newMessages[fullPath];
                    } else {
                        newMessages[fullPath] = [message];
                    }
                    this.validationMessagesRef.current = { ...newMessages };
                },
            },
        };
        return (
            <MetadataContent
                uiProps={this.generateMetadata()}
                overrideProps={overrides}
                {...resolvers}
            />
        );
    }
}

export const SingleClauseVM = SingleClauseComponentVM;
export default withValidation(SingleClauseComponentVM);